import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icons-human",
  "use": "icons-human-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" id=\"icons-human\"><polygon fill=\"currentColor\" fill-rule=\"evenodd\" class=\"cls-1\" points=\"23 10 23 18 14 18 14 13 11 13 11 10 23 10\" /><rect fill=\"currentColor\" fill-rule=\"evenodd\" class=\"cls-2\" x=\"1\" y=\"14\" width=\"12\" height=\"8\" /><rect fill=\"currentColor\" fill-rule=\"evenodd\" class=\"cls-2\" x=\"4\" y=\"7\" width=\"6\" height=\"6\" /><rect fill=\"currentColor\" fill-rule=\"evenodd\" class=\"cls-2\" x=\"14\" y=\"3\" width=\"6\" height=\"6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol